/**
* @ComponentFor Avensia.Shop.Features.Shared.Blocks.ProductCarousel.ProductCarouselBlockViewModel
*/
import React, { Fragment } from 'react';
import classnames from 'classnames';
import connect from 'Shared/connect';
import ReactSwipe from 'react-swipe';
import { SMALL, MEDIUM, LARGE } from 'Shared/breakpoints';
import { on } from 'SiteLayout/Root';
import Button from 'Shared/Button';
import Icon from 'Shared/Icon';
import shallowEquals from 'Shared/shallow-equals';
import ProductCardList from 'Shared/ProductCard/List';
import { viewLayoutTypes } from 'Shared/ViewLayoutSelection';
import * as styles from './base.scss';
import * as gridStyles from 'Shared/ProductCard/Fade/grid.scss';
class ProductCarousel extends React.Component {
    constructor(props) {
        super(props);
        this.setSameHeightOnCard = () => {
            const productCards = this.blockWrapper.querySelectorAll('[class*=base---card---]');
            if (productCards.length >= 1) {
                const productCardsArray = [...productCards];
                const maxHeight = Math.max(...productCardsArray.map(c => c.clientHeight));
                this.cardHeight = maxHeight;
            }
        };
        this.renderPrevAndNextButton = (slides, hasNext, hasPrev) => {
            return (slides.length > 1 && (React.createElement(Fragment, null,
                React.createElement(Button, { onClick: () => this.slidePrev(), className: classnames(styles.prev, {
                        [styles.disabled]: !hasPrev,
                    }), appearance: ['secondary', 'round'], disabled: !hasPrev },
                    React.createElement(Icon, { name: "arrow-left" })),
                React.createElement(Button, { onClick: () => this.slideNext(), className: classnames(styles.next, {
                        [styles.disabled]: !hasNext,
                    }), appearance: ['secondary', 'round'], disabled: !hasNext },
                    React.createElement(Icon, { name: "arrow-right" })))));
        };
        this.state = {
            currentIndex: 0,
            isTall: false,
            productsPerSlide: 1,
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = this.props.id !== nextProps.id || !shallowEquals(this.state, nextState, true);
        if (!shouldUpdate) {
            console.info('Ignoring update of ProductCarousel');
        }
        return shouldUpdate;
    }
    componentDidMount() {
        if (this.props.products.length > 0) {
            this.blockWrapper.classList.remove(styles.loading);
            const productsPerSlide = this.productsPerSlide();
            this.setState({ productsPerSlide });
            this.checkIfIsTall();
            this.setSameHeightOnCard();
            this.unbindResize = on('resize', () => {
                this.checkIfIsTall();
                const productsPerSlide = this.productsPerSlide();
                if (this.state.productsPerSlide !== productsPerSlide) {
                    this.setState({ productsPerSlide, currentIndex: 0 });
                }
            });
        }
    }
    componentWillUnmount() {
        if (this.props.products.length > 0) {
            this.unbindResize();
        }
    }
    productsPerSlide() {
        if (this.props.currentBreakpoint < SMALL) {
            return 1;
        }
        else if (this.props.currentBreakpoint <= SMALL) {
            return 2;
        }
        else if (this.props.currentBreakpoint >= MEDIUM && this.props.currentBreakpoint < LARGE) {
            return 3;
        }
        else if (this.props.currentBreakpoint >= LARGE) {
            return 4;
        }
    }
    checkIfIsTall() {
        const isTall = this.blockWrapper && this.blockWrapper.offsetWidth < 350;
        if (this.state.isTall !== isTall) {
            this.setState({ isTall });
        }
    }
    slidePrev() {
        this.swiper.swipe.slide(this.state.currentIndex - 1);
    }
    slideNext() {
        this.swiper.swipe.slide(this.state.currentIndex + 1);
    }
    slideTo(index) {
        this.setState({ currentIndex: index }, () => this.swiper.swipe.slide(index));
    }
    render() {
        const isMobile = this.props.currentBreakpoint < SMALL;
        if (this.props.products.length === 0) {
            return null;
        }
        let slides = [[]];
        let count = 0;
        let index = 0;
        this.props.products.forEach(product => {
            if (!isMobile || (isMobile && index < 4)) {
                if (count === this.state.productsPerSlide) {
                    slides.push([]);
                    index++;
                    count = 0;
                }
                slides[index].push(product);
                count++;
            }
        });
        const hasNext = this.state.currentIndex < slides.length - 1;
        const hasPrev = this.state.currentIndex > 0;
        const renderPrevAndNextButton = this.renderPrevAndNextButton(slides, hasNext, hasPrev);
        return (React.createElement("div", { ref: el => (this.blockWrapper = el), className: classnames(styles.base, styles.loading) },
            React.createElement("div", { className: styles.carouselHeader },
                React.createElement("h2", null, this.props.title),
                React.createElement("div", { className: styles.navigationButtonsWrap }, renderPrevAndNextButton)),
            React.createElement("div", { className: styles.swiperWrap },
                React.createElement(ReactSwipe, { swipeOptions: {
                        continuous: false,
                        callback: index => this.slideTo(index),
                    }, ref: swiper => (this.swiper = swiper), key: slides.length }, slides.map((slide, index) => (React.createElement("div", { key: index },
                    React.createElement(ProductCardList, { staticCardHeight: this.cardHeight, products: slide.slice(0, this.productsPerSlide()), viewLayoutType: viewLayoutTypes.grid.name, className: gridStyles.carouselProductCard })))))),
            React.createElement("ul", { className: styles.swiperPagination }, slides.map(({}, index) => (React.createElement("li", { key: index, className: this.state.currentIndex === index ? styles.active : '', onClick: () => this.slideTo(index) }))))));
    }
}
export default connect(state => ({
    currentBreakpoint: state.currentBreakpoint,
}))(ProductCarousel);
